if (!customElements.get('about-brand-carousel')) {
  class AboutBrandCarousel extends HTMLElement {
      constructor() {
        super();
    
        this.isMouseenter = false;
        this.elements = {
          slider_element: this.querySelector('.brand_swiper')
        }
        this.init();
      }
    
      connectedCallback() {
        if (Shopify.designMode) {
          this.onShopifySectionLoad = this.onSectionLoad.bind(this);
          this.onShopifySectionSelect = this.onSectionSelect.bind(this);
          this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
          document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
          document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
          document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
        }
      }
    
      disconnectedCallback() {
        if (Shopify.designMode) {
          document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
          document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
          document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
        }
      }
    
      onSectionLoad(event) {
        filterShopifyEvent(event, this, this.initSlider.bind(this));
      }
      onSectionSelect(event) {
        filterShopifyEvent(event, this, this.initSlider.bind(this));
      }
      onSectionDeselect(event) {
        filterShopifyEvent(event, this, this.initSlider.bind(this));
      }
    
      init() {
        if (Shopify && Shopify.designMode) this.initSlider();
        setTimeout(() => this.initSlider());
      }
      
    
      initSlider() {

        var swiper = new Swiper(this.elements.slider_element, {
          slidesPerView: 2.5,
          spaceBetween: 8,
          navigation: {
              nextEl: ".swiper-next",
              prevEl: ".swiper-prev",
          },
          breakpoints: {
              640: {
                slidesPerView: 2,
                spaceBetween: 8
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 16
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 24
              },
              1400: {
                slidesPerView: 5,
                spaceBetween: 48,

              }
            }
        });
        
      }
  }
  customElements.define('about-brand-carousel', AboutBrandCarousel);
}